module.exports = __webpack_public_path__ + "img/서브3_패스킥슛.ae8b58fa.svg";